import { render, staticRenderFns } from "./RegistrStandarAccountPlans.vue?vue&type=template&id=27a4090c&"
import script from "./RegistrStandarAccountPlans.vue?vue&type=script&lang=js&"
export * from "./RegistrStandarAccountPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports